import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-useraccess',
  templateUrl: './useraccess.component.html',
  styleUrls: ['./useraccess.component.css']
})
export class UseraccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
